<template>
  <!-- マイタスク「タイムシート確定締」タブ -->
  <div class="time-sheet-kakutei-shime">
    <loading v-if="!isInit"></loading>
    <template v-else>
      <div class="baseinfo">
        <div class="control">
          <div class="search-areas">
            <b>勤務年月／締め日</b>
            <div class="shimebi-selecter flex flex-align-center">
              <month-picker v-model="yearMonthForMonthPicker" @update:modelValue="changeMonth" :disabled="isLoading"
                :clearable=false></month-picker>
              <input-radio :options="OptionConst.SHIME_DAY_TYPE_OPTIONS" v-model="selectedShimeType"
                @update="updateShimeDayType" :disabled="isLoading"></input-radio>
              <div class="flex flex-align-center" v-if="selectedShimeType === OptionConst.SHIME_DAY_TYPE.SHITEIBI">
                <input-text :type="'number'" @change="changeShimeDay" v-model="shimeDay" inputmode="numeric" class="small"
                  :min="1" :max="31"></input-text>
                <p>日</p>
              </div>
            </div>
            <button type="button" class="btn info" @click="searchData" :disabled="isLoading">検索</button>
          </div>
        </div>
      </div>

      <loading v-if="isLoading"></loading>
      <div class="maininfo" v-else>
        <scroll-table v-if="hakenStaffList.length > 0">
          <table>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>ユーザー名</th>
                <th>承認状況</th>
                <th>承認メモ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in hakenStaffList" :key="row.user_id">
                <td>{{ index + 1 }}</td>
                <td>{{ row.staff_name }}</td>
                <td>
                  <!-- icon -->
                  <!-- <div class="icon-container"> -->

                  <template v-if="row.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                    <div class="icon">
                      <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH">
                    </div>
                  </template>

                  <template v-if="row.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                    <div class="icon">
                      <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH">
                    </div>
                  </template>


                  <!-- </div> -->
                  <!-- icon -->

                </td>
                <td>{{ row.syounin_status_notes }}</td>
                <td><button class="btn success" v-on:click="toKinmuList(row)">勤務一覧へ</button></td>
              </tr>
            </tbody>
          </table>
        </scroll-table>
        <p v-else>該当するデータはありません</p>
      </div>
    </template>

  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from 'vue';
import { dateFormat, dateFormatMMDD, timeFormat } from "@/filters/common";
import { useHakenStaffInit } from '@/composable/mytask/hakenstaff/init';
import { useTimeSheetKakuteiShimeInit } from '@/composable/mytask/hakenstaff/list';
import { useTimeSheetKakuteiShime } from '@/store/mytask-time-sheet-kakutei-shime';
import OptionConst from "@/const/Option";
import Const from '@/const/Shinsei/Option';
import { MonthPickerModelValue } from "@/components/form/MonthPicker.vue";
import { useRouter } from 'vue-router';
import { RouterConst } from '@/const/Router';
import { useRoute } from "vue-router";
import { useSyuugyouBasyoInit } from '@/composable/syuubyoubasyo/init';
import { useAuthStore } from '@/store/auth';
import { DialogService } from '@/service/DialogService';
import { PermissionConst } from '@/const/Permission';
import { MyTaskData } from '@/types/Dakoku';

export default defineComponent({
  props: ['options', 'tab'],
  setup(props) {

    const isInit = ref(false)

    // 初期化
    const { hakenStaffList, syouninStatus } = useHakenStaffInit()

    const { getList } = useTimeSheetKakuteiShimeInit()
    const { getSyuugyouBasyoListByUserId, syuugyouBasyoList } = useSyuugyouBasyoInit()
    const authStore = useAuthStore()

    const router = useRouter()

    const shimeDay = ref(OptionConst.SHIME_LAST_DAY)
    const selectedShimeType = ref(OptionConst.SHIME_DAY_TYPE.GETSUMATSU)

    const route = useRoute()

    const whereConditonStore = useTimeSheetKakuteiShime()

    // 勤務一覧の年月指定用
    const year = ref(new Date().getFullYear()); // 初期値として現在の西暦をセット
    const month = ref(new Date().getMonth() + 1); // 初期値として現在の月をセット

    const isLoading = ref(false)

    // MonthPickerに渡すための年月obj
    const yearMonthForMonthPicker = computed((): MonthPickerModelValue => {
      return {
        year: year.value,
        month: month.value - 1 // プログラム上の月番号と表示上の月名の補正
      }
    })

    onMounted(async () => {
      isLoading.value = true
      if (!authStore.user) {
        await DialogService.error({
          title: '',
          html: 'ユーザー情報の取得に失敗しました。<br>お手数をおかけして申し訳ありませんが再度ログインしてください。'
        })
        router.push({ name: RouterConst.LOGIN })
        return
      }

      // この画面は派遣先上長が使う想定であり、派遣先上長は雇用契約を更新しない想定なのでshowOldKeiyakuはfalse
      // ※ 派遣先上長（＝派遣先の会社の責任者）はメディカ社員ではないので雇用契約は不要だが、
      // 就業場所IDを持たせないと紐付けられないデータがあるため雇用契約をデータとして持たせている
      // 23.10.3追記 サーバー側で就業場所IDによる絞り込みを行わなくなった（＝必須ではなくなった）ため上記の運用も行わない想定
      await getSyuugyouBasyoListByUserId(authStore.user.user_id)


      // 23.10.3追記 サーバー側で就業場所IDによる絞り込みを行わなくなった（＝必須ではなくなった）ため警告を非表示に変更（ある程度トライアルで問題なければこのブロック消す）
      // 関連：（#rev(MEDICA_AS/client-server-split-column:514d53e16a)）
      // if (syuugyouBasyoList.value.length < 1) {
      //   await DialogService.error({
      //     title: '',
      //     html: '就業場所情報の取得に失敗しました。<br>お手数をおかけして申し訳ありませんがメディカ担当者へご連絡ください。'
      //   })
      //   router.push({ name: RouterConst.HOME })
      //   return
      // }
      // 削除対象ここまで

      // 遷移元を取得
      let fromPage = route.params.from ? route.params.from as string : ''
      let cond = whereConditonStore.searchItem

      // 年月が保存されていない場合は現在の年月をセット
      let reloadCondition = false
      if (!cond.year) {
        cond.year = year.value
        reloadCondition = true
      }

      if (!cond.month) {
        cond.month = month.value
        reloadCondition = true
      }
      if (!cond.shime) {
        cond.shime = shimeDay.value
        reloadCondition = true
      }

      // 年月の再設定をした場合、条件を取得し直す
      if (reloadCondition) {
        await whereConditonStore.setItem({
          year: cond.year,
          month: cond.month,
          shime: cond.shime
        })
        cond = whereConditonStore.searchItem
        // console.log('検索条件（再読み込み後）', cond)
      }

      // 遷移元が派遣先編集画面で、検索結果が保存されている場合

      // 検索条件を設定
      year.value = cond.year! // 前述の年/月/締め再設定を前提の!指定
      month.value = cond.month! // 前述の年/月/締め再設定を前提の!指定
      shimeDay.value = cond.shime! // 前述の年/月/締め再設定を前提の!指定

      if (shimeDay.value !== OptionConst.SHIME_LAST_DAY) {
        selectedShimeType.value = OptionConst.SHIME_DAY_TYPE.SHITEIBI
      }

      // 送信パラメータ
      await getList({
        year: year.value,
        month: month.value,
        shime: shimeDay.value,
        syuugyouBasyoIds: syuugyouBasyoList.value.map(item => { return item.mst_syuugyou_basyo_id })
      }, hakenStaffList)

      isLoading.value = false
      isInit.value = true
    })

    // MonthPickerで年月を決定した際に実行
    const changeMonth = async (val: MonthPickerModelValue) => {
      month.value = val.month + 1 // プログラム上の月番号と表示上の月名の補正
      year.value = val.year
    };

    // 月締め確定状況の情報を取得します
    const searchData = (async () => {
      isLoading.value = true
      const params = {
        year: yearMonthForMonthPicker.value.year,
        month: yearMonthForMonthPicker.value.month + 1,
        shime: shimeDay.value,
      }

      await whereConditonStore.setItem(params)

      await getList({
        year: year.value,
        month: month.value,
        shime: shimeDay.value,
        syuugyouBasyoIds: syuugyouBasyoList.value.map(item => { return item.mst_syuugyou_basyo_id })
      }, hakenStaffList)

      isLoading.value = false
    })

    // 派遣先リストに切り替え
    const toKinmuList = ((data: MyTaskData) => {
      if(authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)){
        router.push({
          name: RouterConst.HAKEN_KINMU_LIST, params: {
            kintaiSummaryId: data.kintai_summary_id,
          }
        })
      } else{
        router.push({
          name: RouterConst.KINMU_LIST, query: {
            targetUserId: data.user_id,
            targetSyouninGroupId: data.mst_syounin_group_id,
            from: RouterConst.MY_TASK,
            year: year.value,
            month: month.value
          }
        })
      }
    });

    const updateShimeDayType = (() => {
      if (selectedShimeType.value === OptionConst.SHIME_DAY_TYPE.GETSUMATSU) {
        shimeDay.value = OptionConst.SHIME_LAST_DAY
      } else {
        shimeDay.value = 20 // 月末締めの次に多そうなのが20日締めなので
      }
    })

    const changeShimeDay = (() => {
      shimeDay.value = Number(shimeDay.value)
    })

    return {
      isLoading,
      isInit,
      hakenStaffList,
      dateFormat,
      dateFormatMMDD,
      timeFormat,
      RouterConst,
      syouninStatus,
      yearMonthForMonthPicker,
      changeMonth,
      searchData,
      toKinmuList,
      OptionConst,
      Const,
      shimeDay,
      selectedShimeType,
      updateShimeDayType,
      changeShimeDay
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/mytask-time-sheet-kakute-shime.scss';
</style>
